import moment from 'moment'
import { object } from 'prop-types'
import { AnalyticsLayer } from '@opallabs/quanta'
import ExportToCSV from '../ExportToCSV'
import libraryFilterTree, {
  selectedFilterValues,
  exportableSelectedFilters,
  searchTerms,
} from '../FilterBar/FilterBuilders/assetFilter'
import { FilterCategory } from '../FilterBar/queries/types'

const csvParams = (opts) => ({
  brand_id: opts.workspaceId,
  data_type: 'asset',
  filter_attributes: exportableSelectedFilters(opts),
  query: opts.searchTerms,
})

export const filterSieve = (enabledFilters) => {
  const filters = {
    assetStoryIds: [],
    assetTagIds: [],
    assetLabelIds: [],
    value: [],
  }

  enabledFilters.forEach((filter) => {
    switch (filter.payload?.type_key) {
      case 'assetStoryIds':
        filters.assetStoryIds.push(filter.payload.object.id)
        break
      case 'assetTagIds':
        filters.assetTagIds.push(filter.payload.object.id)
        break
      case 'assetLabelIds':
        filters.assetLabelIds.push(filter.payload.object.id)
        break
      case 'assetMediaType':
      case 'assetUsageRights':
      case 'assetAspectRatio':
      case 'assetChannelPhoto':
        filters.value.push(filter.id)
        break
      default:
        break
    }
  })

  return filters
}

const initialSelectedValues = (sidebarFilterSettings, value) => {
  const filters = {
    assetStoryIds: sidebarFilterSettings.selectedFilters.story_ids || [],
    assetTagIds: sidebarFilterSettings.selectedFilters.tags || [],
    assetLabelIds: sidebarFilterSettings.selectedFilters.labels || [],
    value,
  }

  return filters
}

const defaultFilename = () => `Opal_Asset_Export_${moment().format('MMDDYYYY')}`

const AssetExport = (props) => {
  const filterTree = libraryFilterTree(props.sidebarFilterSettings)
  const value = selectedFilterValues(props.sidebarFilterSettings, filterTree)
  const filterProps = {
    filterTree,
    disabledValues: [],
    filterValues: {},
    value,
  }

  return (
    <AnalyticsLayer name="Asset Export">
      <ExportToCSV
        {...props}
        // Disabling all filter categories provided by the useFilters hook,
        // this lets us pass in the backbone-created set of filters
        // in `additionalFilterOptions` to preservee backwards compatibility
        additionalFilterOptions={filterTree}
        disabledFilterCategories={[
          FilterCategory.channel,
          FilterCategory.date,
          FilterCategory.labelSet,
          FilterCategory.story,
          FilterCategory.workflowStatus,
        ]}
        currentStoryUuid={props.currentStory?.uuid}
        filterProps={filterProps}
        filterTree={filterTree}
        withDateRange={false}
        title="Export CSV &bull; Assets"
        filenamePlaceholder="E.g. Asset Data Export"
        searchPlaceholder="Search all assets"
        csvParams={csvParams}
        filterSieve={filterSieve}
        initialSelectedValues={initialSelectedValues(
          props.sidebarFilterSettings,
          value
        )}
        defaultFilename={defaultFilename()}
        value={selectedFilterValues(props.sidebarFilterSettings, filterTree)}
        searchTerms={searchTerms(props.sidebarFilterSettings)}
      />
    </AnalyticsLayer>
  )
}

AssetExport.propTypes = {
  sidebarFilterSettings: object,
  currentStory: object,
}

export default AssetExport
